import { GlobalState } from "../../utils/types";

export const adHocBlueprintListSelector = (state: GlobalState) => state.task.adHocLists;
